// extracted by mini-css-extract-plugin
module.exports = {"socialMedia":"SosialeMedier_socialMedia__FUrna","ikon":"SosialeMedier_ikon__TbgGv"};